import Link from 'next/link';
import { FC } from 'react';
import { Image } from 'atoms/Image/Image';
import { ParseBBCode } from 'atoms/ParseBBCode';
import { Body } from 'atoms/Typography/Typography';
import { Price } from 'molecules/Price';
import { useTranslations } from 'modules/i18n/useTranslations';
import { IAdaptedListProduct } from 'commerce/scayle/utils/adapter/types';
import { ResultTitle } from '../ResultTitle';
import styles from './styles.module.css';

export const SuggestedProducts: FC<{
  products?: IAdaptedListProduct[];
}> = ({ products: suggestions }) => {
  const t = useTranslations();

  return (
    <div>
      <ResultTitle title={t('search.titles.suggested-products')} />
      {suggestions?.map((suggestion) => {
        return (
          <Link
            key={suggestion.referenceKey}
            href={suggestion.href}
            className={styles.product}
          >
            <Image src={suggestion.coverImage} alt={suggestion.name} />
            <div className={styles.productInfo}>
              <Body type="md" className={styles.productName}>
                <ParseBBCode content={suggestion.name} />
              </Body>
              <Price
                className={styles.price}
                amount={suggestion.price.withTax}
                currencyCode={suggestion.price.currencyCode}
                isCrossed={false}
                size="regular"
              />
            </div>
          </Link>
        );
      })}
    </div>
  );
};
